var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-skeleton-wrapper',[_c('div',{staticClass:"tw-flex tw-flex-col"},[_c('b-skeleton',{key:"fotos",staticClass:"tw-w-full tw-p-4 tw-pt-8",attrs:{"height":"448px"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }